import store from '@state/store'

import Router from 'vue-router'

Router.prototype.open = function(routeObject) {
  const { href } = this.resolve(routeObject)
  window.open(href, '_blank')
}

export default [
  {
    path: '/',
    name: 'login',
    component: () => lazyLoadView(import('@views/auth/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // // If the user is already logged in
        // if (store.getters['auth/loggedIn']) {
        //   // Redirect to the home page instead
        //   next({
        //     name: 'home',
        //   })
        // } else {
        //   // Continue to the login page
        //   next()

        next()
        // }
      },
    },
    props: true,
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => lazyLoadView(import('@views/logs/logs')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/home',
    name: 'home',
    component: () => lazyLoadView(import('@views/dashboard/manage-dashboard')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => lazyLoadView(import('@views/dashboard/manage-dashboard')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/manageusers/:id?',
    name: 'manageusers',
    component: () => lazyLoadView(import('@views/users/manage-users')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/edituser/:userId',
    name: 'edituser',
    component: () => lazyLoadView(import('@views/users/edit-user')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/createCustomer',
    name: 'createCustomer',
    component: () => lazyLoadView(import('@views/customers/create-customer')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editcustomer/:id',
    name: 'editcustomer',
    component: () => lazyLoadView(import('@views/customers/edit-customer')),
    meta: {
      authRequired: true,
    },
    params: true,
  },
  {
    path: '/edit-cp-customer/:id',
    name: 'edit-cp-customer',
    component: () => lazyLoadView(import('@views/customers/edit-customer')),
    meta: {
      authRequired: true,
    },
    props: { cpAction: 'CP' },
  },
  {
    path: '/createuser/:id?',
    name: 'createuser',
    component: () => lazyLoadView(import('@views/users/create-user')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  // {
  //   path: '/create-cp-user',
  //   name: 'create-cp-user',
  //   component: () => lazyLoadView(import('@views/users/create-user')),
  //   meta: {
  //     authRequired: true,
  //   },
  //   props: { cpAction: 'CP' },
  // },
  {
    path: '/create-cp-user/:id?',
    name: 'create-cp-user',
    component: () => lazyLoadView(import('@views/users/create-user')),
    meta: {
      authRequired: true,
    },
    props: { cpAction: 'CP' },
  },
  {
    path: '/edit-cp-user/:userId',
    name: 'edit-cp-user',
    component: () => lazyLoadView(import('@views/users/edit-user')),
    meta: {
      authRequired: true,
    },
    props: { cpAction: 'CP' },
  },
  {
    path: '/xactususers/:userId?',
    name: 'xactususers',
    component: () => lazyLoadView(import('@views/users/creditplususers')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/dashboard',
    name: 'DashBoard',
    component: () => lazyLoadView(import('@views/dashboard/manage-dashboard')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => lazyLoadView(import('@views/Profile/view-profile')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/verifyuser',
    name: 'verifyuser',
    component: () => lazyLoadView(import('@views/Profile/verify-user')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/orderreport',
    name: 'orderreport',
    component: () => lazyLoadView(import('@views/orderReport/orderReport1')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/udn',
    name: 'udnCreate',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/UndisclosedDebtNotification/udnCreate'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'UDN Order',
    },
    params: true,
    props: true,
  },
  // {
  //   path: '/ccr/orderreport',
  //   name: 'ccrorderreport',
  //   component: () => lazyLoadView(import('@views/orderReport/order-reports')),
  //   meta: {
  //     authRequired: true,
  //   },
  //   props: { callOrigin: 'CCR' },
  // },
  {
    path: '/orderSummaryCCRMCL',
    name: 'orderSummaryCCRMCL',
    component: () =>
      lazyLoadView(
        import('@views/orderSummary_CCR_MCL_Trimerge/orderSummary-CCR-MCL')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'BCR Order Summary',
    },
    params: true,
    props: true,
  },
  {
    path: '/ccrOrderSummary',
    name: 'ccrOrderSummary',
    component: () =>
      lazyLoadView(import('@views/ccr_OrderSummary/ccrOrderSummary')),
    meta: {
      authRequired: true,
      breadCrumb: 'CCR Order Summary',
    },
    params: true,
    props: true,
  },
  {
    path: '/ccrOrderSummary/:orderId',
    name: 'ccrOrderSummaryO',
    component: () =>
      lazyLoadView(import('@views/ccr_OrderSummary/ccrOrderSummary')),
    meta: {
      authRequired: true,
      breadCrumb: 'CCR Order Summary',
    },
    params: true,
    props: true,
  },
  {
    path: '/ccrOrderSummary/:orderId/:productId',
    name: 'ccrOrderSummaryOP',
    component: () =>
      lazyLoadView(import('@views/ccr_OrderSummary/ccrOrderSummary')),
    meta: {
      authRequired: true,
      breadCrumb: 'CCR Order Summary',
    },
    params: true,
    props: true,
  },
  {
    path: '/floodOrderSummary/:orderId',
    name: 'floodOrderSummary',
    component: () =>
      lazyLoadView(import('@views/flood-OrderSummary/floodOrderSummary')),
    meta: {
      authRequired: true,
    },
    params: true,
    props: true,
  },
  {
    path: '/liendsandjudgementSummary/:orderId',
    name: 'liendsandjudgementSummary',
    component: () =>
      lazyLoadView(
        import('@views/liendsandjudgementSummary/liensandjudgmentsummary')
      ),
    meta: {
      authRequired: true,
    },
    params: true,
    props: true,
  },
  {
    path: '/bcir2Summary',
    name: 'bcir2Summary',
    component: () =>
      lazyLoadView(import('@/src/router/views/bcir2Summary/bcir2Summary')),
    meta: {
      authRequired: true,
      breadCrumb: 'BCR Order Summary',
    },
    props: true,
  },
  {
    path: '/pprSearchResults',
    name: 'pprSearchResults',
    component: () =>
      lazyLoadView(
        import('@/src/router/views/pprSearchResults/pprSearchResults')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/blendedSearchResults',
    name: 'blendedSearchResults',
    component: () =>
      lazyLoadView(
        import('@/src/router/views/blendedSearchResults/blendedSearchResults')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/paynetSearchResults',
    name: 'paynetSearchResults',
    component: () =>
      lazyLoadView(
        import('@/src/router/views/paynetSearchResults/paynetSearchResults')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/blendedReportSummary/:orderId',
    name: 'blendedReportSummary',
    component: () =>
      lazyLoadView(
        import('@/src/router/views/blendedReportSummary/blendedReportSummary')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/manageProducts',
    name: 'manageProducts',
    component: () => lazyLoadView(import('@views/products/manage-products')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/manageProducts/:id',
    name: 'manageProductsEdit',
    component: () => lazyLoadView(import('@views/products/manage-products')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/manageProducts/:id/create',
    name: 'createProduct',
    component: () => lazyLoadView(import('@views/products/create-product')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/manageProducts/:id/edit/:productId',
    name: 'editProduct',
    component: () => lazyLoadView(import('@views/products/edit-product')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/rescoreCreate/:orderId',
    name: 'rescoreCreate',
    component: () => lazyLoadView(import('@views/rescore/rescoreCreate')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/rescoreProcessor/:rescoreId',
    name: 'rescoreProcessor',
    component: () => lazyLoadView(import('@views/rescore/rescoreProcessor')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/createSupplementOrder',
    name: 'createSupplementOrder',
    component: () =>
      lazyLoadView(
        import('@views/createSupplementOrder/createSupplementOrder')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/createliensandjudgementSupplementOrder/:orderId',
    name: 'createliensandjudgementSupplementOrder',
    component: () =>
      lazyLoadView(
        import(
          '@views/liensandjudgementSupplement/createliensandjudgementSupplementorder'
        )
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/createSupplementOrder/:orderId',
    name: 'createSupplementOrderWithParam',
    component: () =>
      lazyLoadView(
        import('@views/createSupplementOrder/createSupplementOrder')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/editSupplementOrder',
    name: 'editSupplementOrder',
    component: () =>
      lazyLoadView(import('@views/editSupplementOrder/editSupplementOrder')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/editSupplementOrder/:requestNumber/:parentRequestId',
    name: 'editSupplementOrderWithParam',
    component: () =>
      lazyLoadView(import('@views/editSupplementOrder/editSupplementOrder')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/inquiryModel',
    name: 'inquiryModel',
    component: () =>
      lazyLoadView(import('@views/editSupplementOrder/inquiryModel')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/myQueue',
    name: 'supplementsQueue',
    component: () =>
      lazyLoadView(import('@views/supplementsQueue/supplementsQueue')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/score-report',
    name: 'scorereport',
    component: () =>
      lazyLoadView(
        import('@views/managementReports/ScoreReports/score-report')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/transaction-report',
    name: 'transactionreport',
    component: () =>
      lazyLoadView(
        import('@views/managementReports/TransactionReport/transaction-report')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/wco-transactions',
    name: 'wco-transactions',
    component: () =>
      lazyLoadView(
        import('@views/managementReports/WcoTransactions/wco-transactions')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/manage-user-report',
    name: 'manageuserreport',
    component: () =>
      lazyLoadView(import('@views/managementReports/Users/manage-user-report')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/manage-customer-report',
    name: 'managecustomerreport',
    component: () =>
      lazyLoadView(
        import('@views/managementReports/Customers/manage-customer-report')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/activity-summary',
    name: 'activitysummary',
    component: () =>
      lazyLoadView(
        import('@views/managementReports/ActivityReport/activity-summary')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/doc-management',
    name: 'docManagement',
    component: () => lazyLoadView(import('@views/docManagement/docManagement')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createnewpassword',
    name: 'createnewpassword',
    component: () =>
      lazyLoadView(import('@views/auth/ResetPassword/reset-password')),
  },
  {
    path: '/resetPasswordSuccess',
    name: 'resetPasswordSuccess',
    component: () =>
      lazyLoadView(import('@views/auth/account-reset-password-success')),
  },
  {
    path: '/securityquestions',
    name: 'getSecurityQuestionsForLogIn',
    component: () =>
      lazyLoadView(import('@views/auth/ForgotPassword/security-questions')),
  },
  {
    path: '/resetPasswordConfirm',
    name: 'resetPasswordConfirm',
    component: () =>
      lazyLoadView(import('@views/auth/ResetPassword/reset-password-confirm')),
    // meta: {
    //   authRequired: true,
    // },
  },
  {
    path: '/loanOfficers',
    name: 'loanOfficers',
    component: () =>
      lazyLoadView(import('@views/loanOfficers/manage-loan-officers')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/createloanOfficers',
    name: 'createloanOfficer',
    component: () =>
      lazyLoadView(import('@views/loanOfficers/create-loan-officer')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editloanOfficers',
    name: 'editloanOfficer',
    component: () =>
      lazyLoadView(import('@views/loanOfficers/edit-loan-officers')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/customizeProductUrl/:userId',
    name: 'customizeProductUrl',
    component: () =>
      lazyLoadView(import('@views/loanOfficers/customize-product-url')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/lenders',
    name: 'lenders',
    component: () => lazyLoadView(import('@views/lenders/manage-lenders')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/editlender',
    name: 'editlender',
    component: () => lazyLoadView(import('@views/lenders/edit-lender')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createlender',
    name: 'createlender',
    component: () => lazyLoadView(import('@views/lenders/create-lender')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/usagereport',
    name: 'usagereport',
    component: () => lazyLoadView(import('@views/usageReport/usage-report')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/documentupload',
    name: 'documentupload',
    component: () =>
      lazyLoadView(import('@views/documentUpload/document-upload')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/volumereport',
    name: 'volumereport',
    component: () =>
      lazyLoadView(import('@views/reports/volumeReport/volume-report')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/billingreport',
    name: 'billingreport',
    component: () =>
      lazyLoadView(import('@views/reports/billingReport/billing-report')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/score-disclosure-report',
    name: 'scoreDisclosureReport',
    component: () =>
      lazyLoadView(
        import('@views/reports/scoreDisclosure/score-disclosure-report')
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/prequalTemplate/:customerId',
    name: 'prequalTemplate',
    component: () => lazyLoadView(import('@views/lenders/prequal-template')),
    meta: {
      authRequired: true,
    },
    // props: true,
  },
  {
    path: '/consumerConsentReport',
    name: 'consumerConsentReport',
    component: () =>
      lazyLoadView(import('@views/reports/consumer-consent-report')),
    meta: {
      authRequired: true,
      breadCrumb: 'Consumer Consent Report',
    },
  },
  {
    path: '/consumerCreditActivityReport',
    name: 'consumerCreditActivityReport',
    component: () =>
      lazyLoadView(import('@views/reports/consumer-credit-activity-report')),
    meta: {
      authRequired: true,
      breadCrumb: 'Consumer Credit Activity Report',
    },
  },
  {
    path: '/customers',
    name: 'customers',
    component: () => lazyLoadView(import('@views/customers/manage-customer')),
    meta: {
      authRequired: true,
      breadCrumb: 'Customers',
    },
    props: true,
  },
  {
    path: '/xactusdetails',
    name: 'xactusdetails',
    component: () => lazyLoadView(import('@views/customers/creditplusdetails')),
    meta: {
      authRequired: true,
      breadCrumb: 'xactusdetails',
    },
    props: true,
  },
  {
    path: '/forgotusername',
    name: 'forgotusername',
    component: () =>
      lazyLoadView(import('@views/auth/ForgotPassword/forgot-username')),
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: () =>
      lazyLoadView(import('@views/auth/ForgotPassword/forgot-password')),
  },
  {
    path: '/forgotpasswordotp',
    name: 'forgotpasswordotp',
    component: () =>
      lazyLoadView(import('@views/auth/ForgotPassword/forgot-password-otp')),
    props: true,
  },
  {
    path: '/forgotpasswordotpoptions/:tokenid',
    name: 'forgotpasswordotpoptions',
    component: () =>
      lazyLoadView(
        import('@views/auth/ForgotPassword/forgot-password-otp-options')
      ),
    props: true,
  },
  {
    path: '/ipwhitelistingotp',
    name: 'ipwhitelistingotp',
    component: () =>
      lazyLoadView(import('@views/auth/IPWhiteListing/ip-whitelisting-otp')),
    props: true,
  },
  {
    path: '/ipwhitelistingotpoptions',
    name: 'ipwhitelistingotpoptions',
    component: () =>
      lazyLoadView(
        import('@views/auth/IPWhiteListing/ip-whitelisting-otp-options')
      ),
    props: true,
  },
  {
    path: '/activateaccount/:tokenid',
    name: 'activeaccount',
    component: () => lazyLoadView(import('@views/auth/active-account')),
    props: true,
  },
  {
    path: '/about',
    name: 'about',
    component: () => lazyLoadView(import('@views/about')),
    props: true,
  },
  {
    path: '/errorpage',
    name: 'errorpage',
    component: () => lazyLoadView(import('@views/auth/errorpage')),
    props: true,
  },
  {
    path: '/accountsuccessfully',
    name: 'accountsuccessfully',
    component: () => lazyLoadView(import('@views/auth/account-successful')),
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    component: () => lazyLoadView(import('@views/auth/change-password')),
    meta: {
      authRequired: true,
      breadCrumb: 'Change Password',
    },
  },
  {
    path: '/savemclcredential',
    name: 'savemclcredential',
    component: () => lazyLoadView(import('@views/auth/save-mcl-credential')),
    meta: {
      authRequired: true,
      breadCrumb: 'Save MCL Credentials',
    },
    props: true,
  },
  {
    path: '/mclotp',
    name: 'mclotp',
    component: () => lazyLoadView(import('@views/auth/MCLOTP/mcl-otp')),
    props: true,
  },
  {
    path: '/mclotpoptions',
    name: 'mclotpoptions',
    component: () => lazyLoadView(import('@views/auth/MCLOTP/mcl-otp-options')),
    props: true,
  },

  {
    path: '/serviceProviders',
    name: 'serviceProviders',
    component: () =>
      lazyLoadView(
        import(
          '@/src/router/views/Administration/ThirdPartyVendors/manage-third-party-vendor'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Service Providers',
    },
    props: true,
  },
  {
    path: '/editServiceProviders',
    name: 'editServiceProviders',
    component: () =>
      lazyLoadView(
        import(
          '@/src/router/views/Administration/ThirdPartyVendors/third-party-vendor'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Edit Service Providers',
    },
    props: true,
  },
  {
    path: '/denali',
    name: 'denali',
    component: () => lazyLoadView(import('@views/denali/denali')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => lazyLoadView(import('@views/settings/Settings')),
    meta: {
      authRequired: true,
      breadCrumb: 'settings',
    },
  },
  {
    path: '/globalsetup',
    name: 'globalSetup',
    component: () => lazyLoadView(import('@views/globalSetup/globalSetup')),
    meta: {
      authRequired: true,
      breadCrumb: 'globalSetup',
    },
  },
  {
    path: '/monitoringservices',
    name: 'monitoringservices',
    component: () =>
      lazyLoadView(
        import('@views/Administration/MonitoringServices/monitoring-services')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'monitoringServices',
    },
    props: true,
  },
  {
    path: '/account-monitoring-services',
    name: 'accountmonitoringservices',
    component: () =>
      lazyLoadView(
        import('@views/Services/monitoringServices/account-monitoring-services')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'monitoringServices',
    },
    props: true,
  },
  {
    path: '/rateSheet',
    name: 'rateSheet',
    component: () =>
      lazyLoadView(import('@views/Administration/rateSheet/rateSheet')),
    meta: {
      authRequired: true,
      breadCrumb: 'rateSheet',
    },
    props: true,
  },
  {
    path: '/monitoringservices/create/:portfolioid',
    name: 'createMonitoringServices',
    component: () =>
      lazyLoadView(
        import('@views/Administration/MonitoringServices/monitoring-service')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Add New Subscription',
    },
    props: true,
  },
  {
    path: '/monitoringservices/edit',
    name: 'editMonitoringServices',
    component: () =>
      lazyLoadView(
        import(
          '@views/Administration/MonitoringServices/edit-monitoring-service'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Edit Monitoring Services',
    },
    props: true,
  },
  {
    path: '/fraudreportxpackages',
    name: 'fraudPlusPackages',
    component: () =>
      lazyLoadView(
        import('@views/Administration/FraudPlus/fraudplus-packages')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Fraudplus packages',
    },
    props: true,
  },
  {
    path: '/create-freportx-packages',
    name: 'createFPlusPackages',
    component: () =>
      lazyLoadView(
        import('@views/Administration/FraudPlus/create-fplus-packages')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Create Fraudplus packages',
    },
    props: true,
  },
  {
    path: '/fraudreportx-summary/:orderId',
    name: 'fraudplusSummaryPage',
    component: () =>
      lazyLoadView(
        import('@views/Administration/FraudPlus/fraudplus-order-summarypage')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/fraudreportx-finalreport/:orderId/:Token?',
    name: 'fraudplusReportPage',
    component: () =>
      lazyLoadView(
        import('@views/Administration/FraudPlus/fraudplus-finalreport-page')
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/edit-freportx-packages/:id',
    name: 'editFPlusPackages',
    component: () =>
      lazyLoadView(
        import('@views/Administration/FraudPlus/create-fplus-packages')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Create Fraudplus packages',
    },
    props: true,
  },
  {
    path: '/fraudreportxratesheet',
    name: 'fraudPlusRatesheet',
    component: () =>
      lazyLoadView(
        import('@views/Administration/FraudPlus/fraudplus-ratesheet')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Fraudplus ratesheet',
    },
    props: true,
  },
  {
    path: '/fraudreportxIntegrationpackages',
    name: 'fraudPlus-integration-packages',
    component: () =>
      lazyLoadView(
        import('@views/FraudPlusIntegration/fraudplus-integration-packages')
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/createFreportxIntegrationPackages',
    name: 'create-fplus-integration-packages',
    component: () =>
      lazyLoadView(
        import('@views/FraudPlusIntegration/create-fplus-integration-packages')
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/editFreportxIntegrationPackages/:id',
    name: 'editFplusIntegrationPackages',
    component: () =>
      lazyLoadView(
        import('@views/FraudPlusIntegration/create-fplus-integration-packages')
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/create-bureau-connections',
    name: 'createBureauConnections',
    component: () =>
      lazyLoadView(
        import('@views/Administration/BureauConnections/bureau-connections')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Create Bureau Connections',
    },
    props: true,
  },
  {
    path: '/edit-bureau-connections',
    name: 'editBureauConnections',
    component: () =>
      lazyLoadView(
        import('@views/Administration/BureauConnections/bureau-connections')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Edit Bureau Connections',
    },
    props: true,
  },
  {
    path: '/bureauconnections',
    name: 'bureauConnections',
    component: () =>
      lazyLoadView(
        import('@views/Administration/BureauConnections/bureau-connections')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Bureau Connections',
    },
    props: true,
  },
  {
    path: '/createconnection',
    name: 'createconnection',
    component: () =>
      lazyLoadView(
        import('@views/Administration/BureauConnections/create-connection')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Bureau Connections',
    },
    props: true,
  },
  {
    path: '/editconnection/:id',
    name: 'editconnection',
    component: () =>
      lazyLoadView(
        import('@views/Administration/BureauConnections/create-connection')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Bureau Connections',
    },
    props: true,
  },
  {
    path: '/reportlayoutdesigner',
    name: 'reportLayoutDesigner',
    component: () =>
      lazyLoadView(
        import('@views/Administration/LayoutDesigner/report-layout-designer')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Layout Designer',
    },
    props: true,
  },
  {
    path: '/editor-layout-designer/:id',
    name: 'editorLayoutDesigner',
    component: () =>
      lazyLoadView(
        import('@views/Administration/LayoutDesigner/editor-layout-designer')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Layout Designer',
    },
    props: true,
  },
  {
    path: '/editor-layout-designer',
    name: 'editorLayoutDesignerNew',
    component: () =>
      lazyLoadView(
        import('@views/Administration/LayoutDesigner/editor-layout-designer')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Layout Designer',
    },
    props: true,
  },
  {
    path: '/voe-securedlink/:uID',
    name: 'voesecuredlink',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfEmployment/VoeSecuredlink'
        )
      ),
    meta: {
      authRequired: false,
      breadCrumb: 'VoE Order Summary',
    },
  },
  {
    path: '/vod-securedlink/:guid',
    name: 'vodsecuredLink',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfDeposit/VodSecuredLink'
        )
      ),
    meta: {
      authRequired: false,
      breadCrumb: 'VoD Order Summary',
    },
  },
  {
    path: '/final-Submission/',
    name: 'vod-Submission',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfDeposit/vod-submission'
        )
      ),
    meta: {
      authRequired: false,
      breadCrumb: 'VoD Order Summary',
    },
  },
  {
    path: '/voe-Submission/',
    name: 'voe-Submission',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfEmployment/voe-Submission'
        )
      ),
    meta: {
      authRequired: false,
      breadCrumb: 'VoE Order Summary',
    },
  },
  {
    path: '/voe-dibuscreen/:id',
    name: 'voe-otpscreen',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfEmployment/OtpScreen'
        )
      ),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/voeself-otpscreen/:guid',
    name: 'voe-selfverify',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfEmployment/VoeSelfVerifyOtp'
        )
      ),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/vod-otpscreen/:guid',
    name: 'vod-otpscreen',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfDeposit/vod-otpscreen'
        )
      ),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/fiserv-otpscreen/:guid',
    name: 'fiserv-otpscreen',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfAssetFiserv/voa-fiserv-otpscreen'
        )
      ),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/fiserv-finalreport/:orderId',
    name: 'fiservReportPage',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfAssetFiserv/voa-fiserv-finalreport-page'
        )
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/voe-results/:orderId',
    name: 'voeResults',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfEmployment/voe-results'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'VoE Order Summary',
    },
  },
  {
    path: '/vod-summary/:orderId',
    name: 'vodSummary',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfDeposit/vod-summaryPage'
        )
      ),
  },

  {
    path: '/voe-self-securedLink/:guid',
    name: 'voeSelfSecuredLink',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VOESelfEmployedVerification/voe-self-employed-securedlink'
        )
      ),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/voe-selfemployed-results/:orderId',
    name: 'VoeSelfEmployedResults',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VOESelfEmployedVerification/voe-self-Employed-Results'
        )
      ),
  },
  {
    path: '/UDNOrderSummary/:orderId',
    name: 'UDNOrderSummary',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/UndisclosedDebtNotification/UDN-Order-Summary'
        )
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/UDNReportPage',
    name: 'UDNReportPage',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/UndisclosedDebtNotification/UDN-Final-Report.vue'
        )
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/fiserv-widgets/:guid',
    name: 'fiservWidgetsGuid',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfAssetFiserv/Fiserv-widgets-guid.vue'
        )
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/fiserv-widgets',
    name: 'fiservWidgets',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfAssetFiserv/Fiserv-widgets.vue'
        )
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/mvxmortgageverification-widgets/:guid',
    name: 'mvxMortgageVerificationWidgetsGuid',
    component: () =>
      lazyLoadView(
        import(
          '@/src/router/views/Services/OrderReports/VOM/mvx-mortgageverification-widgets-guid.vue'
        )
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/mvx-mortgageverification-widgets',
    name: 'mvxMortgageVerificationWidgets',
    component: () =>
      lazyLoadView(
        import(
          '@/src/router/views/Services/OrderReports/VOM/mvx-mortgageverification-widgets.vue'
        )
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/voa-results/:orderId',
    name: 'voaResults',
    component: () =>
      lazyLoadView(
        import('@views/Services/OrderReports/VerificationOfAsset/voa-results')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Voa Order Summary',
    },
    props: true,
  },
  {
    path: '/voe-processing/:id',
    name: 'voeProcessing',
    component: () =>
      lazyLoadView(import('@views/Services/OrderReports/voe-processing')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/Vod-processing/:id',
    name: 'vodProcessing',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfDeposit/Vod-processing'
        )
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/voa-fiserv-summary/:orderId',
    name: 'voaFiservSummary',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfAssetFiserv/voa-fiserv-summary'
        )
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/MVx-MortgageVerification-summary/:orderId',
    name: 'vomFiservSummary',
    component: () =>
      lazyLoadView(
        import('@views/Services/OrderReports/VOM/vom-fiserv-summary')
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/vom-order-json',
    name: 'vomOrderJson',
    component: () =>
      lazyLoadView(import('@views/Services/OrderReports/VOM/vom-order-json')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/voa-fiserv-thanks/',
    name: 'voaFiserThanks',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfAssetFiserv/voa-fiserv-thanks'
        )
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/vom-fiserv-thanks/',
    name: 'vomFiserThanks',
    component: () =>
      lazyLoadView(
        import('@views/Services/OrderReports/VOM/vom-fiserv-thanks')
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/fiserv-otpscreen/:guid',
    name: 'fiservotpscreen',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VerificationOfAssetFiserv/voa-fiserv-otpscreen.vue'
        )
      ),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/vom-fiserv-otpscreen/:guid',
    name: 'vomfiservotpscreen',
    component: () =>
      lazyLoadView(
        import('@views/Services/OrderReports/VOM/vom-fiserv-otpscreen.vue')
      ),
    meta: {
      authRequired: false,
    },
    props: true,
  },
  {
    path: '/pdfviewer',
    name: 'pdfviewer',
    component: () => lazyLoadView(import('@views/common/pdfViewer')),
    meta: {
      authRequired: false,
      breadCrumb: 'pdfviewer',
    },
    props: true,
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        // const authRequiredOnPreviousRoute = routeFrom.matched.some(
        //   (route) => route.meta.authRequired
        // )
        // Navigate back to previous page
        next({
          name: 'login',
        })
      },
    },
  },
  {
    path: '/Voe-selfemployed-processing/:orderId',
    name: 'voeSelfEmployeedProcessing',
    component: () =>
      lazyLoadView(
        import(
          '@views/Services/OrderReports/VOESelfEmployedVerification/voe-self-employed-processing'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Edit Self Employed Verification',
    },
    props: true,
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/401',
    name: '401',
    component: () => lazyLoadView(import('@views/_401')),
  },
  {
    path: '/agent-view-profile/:uid',
    name: 'agentViewProfile',
    component: () =>
      lazyLoadView(import('@views/Profile/support-agent-view-profile')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/resetnewpassword/:tokenId',
    name: 'resetpasswordonlogin',
    component: () =>
      lazyLoadView(import('@views/auth/ResetPassword/reset-password-onlogin')),
  },

  /** HMDA ROUTES */
  {
    path: '/hmda',
    name: 'hmda',
    component: () => lazyLoadView(import('@views/HMDA/HmdaDashboard.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/hmda/rolecheck',
    name: 'hmda-rolecheck',
    component: () =>
      lazyLoadView(import('@/src/router/views/HMDA/RoleCheckTest.vue')),
    meta: {
      authRequired: true,
    },
  },

  {
    path: '/hmda/projects/create',
    name: 'hmda-projects-create',
    component: () => lazyLoadView(import('@views/HMDA/CreateProject.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/hmda/projects/:id',
    name: 'hmda-project-details',
    component: () => lazyLoadView(import('@views/HMDA/ProjectDetails.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/hmda/projects',
    name: 'hmda-view-projects',
    component: () => lazyLoadView(import('@views/HMDA/ViewProjects.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/hmda/projects/:projectId/loans/details',
    name: 'hmda-project-loan-details',
    component: () => lazyLoadView(import('@views/HMDA/LoanDetails.vue')),
    meta: {
      authRequired: true,
    },
    props: true,
  },
  {
    path: '/hmda/rules',
    name: 'hmda-view-rules',
    component: () => lazyLoadView(import('@views/HMDA/ViewRules.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/hmda/lars',
    name: 'hmda-lars',
    component: () => lazyLoadView(import('@views/HMDA/Lars.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/hmda/management',
    name: 'hmda-management',
    component: () => lazyLoadView(import('@views/HMDA/Management.vue')),
    meta: {
      authRequired: true,
    },
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
